'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { createPolymorphicComponent, Collapse } from '@s7/layout';
import { useProps } from '@s7/styles';
import { useAccordionContext } from '../../Accordion.context.js';
import { useAccordionItemContext } from '../AccordionItem.context.js';
import { IDENT_ACCORDION_PANEL, panelDefaultProps } from './AccordionPanel.contract.js';
import useStyles from './AccordionPanel.styles.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var _AccordionPanel = /*#__PURE__*/ forwardRef(function(props, ref) {
    var context = useAccordionContext();
    var value = useAccordionItemContext().value;
    var _useProps = useProps(IDENT_ACCORDION_PANEL, panelDefaultProps, props), _useProps_ = _useProps[0], children = _useProps_.children, className = _useProps_.className, sxs = _useProps[1], others = _object_without_properties_loose(_useProps[0], [
        "children",
        "className"
    ]);
    var _useStyles = useStyles(null, sxs, IDENT_ACCORDION_PANEL), classes = _useStyles[0], cx = _useStyles[1];
    return /*#__PURE__*/ jsx(Collapse, _extends({}, others, {
        ref: ref,
        "aria-labelledby": context.getControlId(value),
        className: cx(classes.panel, className),
        id: context.getRegionId(value),
        opened: context.isItemActive(value),
        role: "region",
        transitionDuration: context.transitionDuration,
        children: /*#__PURE__*/ jsx("div", {
            className: classes.content,
            children: children
        })
    }));
});
var AccordionPanel = createPolymorphicComponent(_AccordionPanel);
AccordionPanel.displayName = "Accordion.Item.Panel";

export { AccordionPanel };
